import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../../constants/routes'
import FutureElevation from '../../../widgets/FutureElevation';
import { setCurrentElevationMeta } from '../../../../store/actions/floorActions';

import { get } from 'lodash'

class BriefElevation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            coordinates: [],
            title: "",
            description: "",
            files: [],

        }
    }

    /// README: Choose elevation to open
    chooseElevation = (elevationid, elevationMap) => {
        const elevationidMap = { floodid: elevationid };
        const elevationMeta = { ...elevationMap, ...elevationidMap };
        this.props.setCurrentElevationMeta(elevationMeta);
    }

    /// README: Compare to sort
    compare(a, b) {
        if ('dateCreated' in a && 'dateCreated' in b) {
            if (a.dateCreated && b.dateCreated) {
                if (a.dateCreated.seconds < b.dateCreated.seconds) {
                    return -1;
                }
                if (a.dateCreated.seconds > b.dateCreated.seconds) {
                    return 1;
                }
            }
        }
        return 0;
    }

    componentDidMount() {
        const { selectedMarkerid, floorMarkers } = this.props;
        this.setState({
            ...floorMarkers[selectedMarkerid],
        })
    }

    render() {
        const { formLabelStyle, commons } = this.props;

        const { title, description, floorsMap, coordinates } = this.state;
        const descriptionCount = description.length;

        return (
            <React.Fragment>
                {/* File upload button */}
                <div className="form-group text-left">
                    {/* <label style={formLabelStyle}>Added {commons.drawings}</label>
                    <br /> */}
                    <div className="card">
                        <div className="m-3">
                            {floorsMap !== undefined ? floorsMap !== null ? Object.keys(floorsMap).length !== 0 ? Object.values(floorsMap).sort(this.compare).map((val, i) => (
                                <div key={i}>
                                    <button type="button" className="btn btn-flat btn-sm" onClick={() => this.chooseElevation(val.elevationid, val)} style={{ fontStyle: "normal", fontSize: "16px", fontWeight: "normal" }} data-toggle="tooltip" data-placement="top" title={val.name}>
                                        <Link to={{ pathname: `${ROUTES.IND_PROJECT_ELEVATION_MAP_EDITOR}` }} style={{ color: "black" }}>
                                            {/* {i + 1}. {val.name.length > 40 ? `${val.name.substring(0, 40)}...` : `${val.name}`} */}
                                            <span style={{ fontStyle: "italic", fontSize: "12px", color: "GrayText" }}>
                                                <FutureElevation isCirclePreview={true} elevationMap={val} styleClass="" height="150px" />
                                            </span>
                                        </Link>
                                    </button>
                                </div>
                            )) : "No elevations found" : "No elevations found" : "No elevations found"}
                        </div>
                    </div>
                </div>
                <br/>
                {/* Title and description */}
                <div className="form-group text-left">
                    <label htmlFor="inputText" style={formLabelStyle}>Title</label>
                    <input type="text" className="form-control form-control-sm" id="viewTitle" defaultValue={title} readOnly={true} />
                </div>
                <div className="form-group text-left">
                    <label htmlFor="inputText" style={formLabelStyle}>Description</label>
                    <span className="ml-3" style={{ fontSize: "12px", color: "GrayText" }}>({descriptionCount}/200)</span>
                    <textarea maxLength="200" rows="3" className="form-control form-control-sm" id="viewDescription" defaultValue={description} readOnly={true} />
                </div>
                {/* <div className="form-group text-left">
                    <label htmlFor="inputText" style={formLabelStyle}>Coordinates</label>
                    <input type="text" className="form-control form-control-sm" id="editCoordinates" onChange={this.handleChange} defaultValue={coordinates} readOnly={true}/>
                </div> */}
                <hr />
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        floorMarkers: state.firestore.data.FloorMarkers,
        mut: state.marker,
        formLabelStyle: state.appControl.formLabelStyle,

        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),

        commons: state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentElevationMeta: (elevationMeta) => dispatch(setCurrentElevationMeta(elevationMeta)),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BriefElevation)
